<template>
  <div class="HostCity">
    <div class="module">
      <title-name name="热招城市"></title-name>
      <div class="host-list">
        <div class="host-item" v-for="(item, index) in cityList" :key="index" @click="goto(item.code)">
          <div class="img">
            <img v-lazy="cityImg[index].url" alt="city">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end 热招城市 -->
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import TitleName from '../../components/TitleName'
import city from '../../components/cityList'
export default {
  name: 'HostCity',
  data () {
    return {
      cityList: city, // 城市列表 
      cityImg: [ // 城市图片列表
        {chinaName: '北京', url: require('@/common/images/talent/index/city/city (1).png')},
        {chinaName: '上海', url: require('@/common/images/talent/index/city/city (2).png')},
        {chinaName: '广州', url: require('@/common/images/talent/index/city/city (3).png')},
        {chinaName: '深圳', url: require('@/common/images/talent/index/city/city (4).png')},
        {chinaName: '成都', url: require('@/common/images/talent/index/city/city (5).png')},
        {chinaName: '杭州', url: require('@/common/images/talent/index/city/city (6).png')},
        {chinaName: '苏州', url: require('@/common/images/talent/index/city/city (7).png')},
        {chinaName: '东莞', url: require('@/common/images/talent/index/city/city (8).png')},
        {chinaName: '佛山', url: require('@/common/images/talent/index/city/city (9).png')},
        {chinaName: '武汉', url: require('@/common/images/talent/index/city/city (10).png')},
        {chinaName: '长沙', url: require('@/common/images/talent/index/city/city (11).png')},
        {chinaName: '重庆', url: require('@/common/images/talent/index/city/city (12).png')}
      ]
    }
  },
  mounted () {},
  methods: {
    goto(jobplace) {
      this.$router.push({
        name: "TalentSearch",
        query: {jobplace: jobplace}
      })
    },
    requireUrl(url) {
      return require(url)
    },
    ...mapActions([
      'setLoading'
    ])
  },
  filters: {
  },
  watch: {},
  computed: {
    ...mapGetters([
        'user'
    ])
  },
  components: {
      TitleName
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.HostCity {
  padding-top: 40px;
  padding-bottom: 30px;
  background: #fff;

  .host-list {
    margin-top: 29px;
    margin-left: -7px;
    overflow: hidden;
    .host-item {
      position: relative;
      float: left;
      margin-bottom: 7px;
      margin-left: 7px;
      width: 194px;
      height: 90px;
      overflow: hidden;
      cursor: pointer;
      transition: all .5s;
      -webkit-transition: all .5s;
      -moz-transition: all .5s;
      -o-transition: all .5s;
      -ms-transition: all .5s;

       &::before {
          content: '';
          position: absolute;
          margin: auto;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          z-index: 2;
          display: block;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          box-shadow: 0 0 15px 0 rgba(0, 0, 0, .5);
          -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, .5);
          -ms-box-shadow: 0 0 15px 0 rgba(0, 0, 0, .5);
          -moz-box-shadow: 0 0 15px 0 rgba(0, 0, 0, .5);
          -o-box-shadow: 0 0 15px 0 rgba(0, 0, 0, .5);
          background: rgba(0, 0, 0, .2);
          transition: all .5s;
          -webkit-transition: all .5s;
          -moz-transition: all .5s;
          -o-transition: all .5s;
          -ms-transition: all .5s;
        } 

      &:hover {
        img {
          transform: scale(1.2);
          -ms-transform: scale(1.2);
          -webkit-transform: scale(1.2);
          -moz-transform: scale(1.2);
          -o-transform: scale(1.2);
        }
        &::before {
            content: '';
            position: absolute;
            z-index: 2;
            display: block;
            width: 194px;
            height: 90px;
            border-radius: 0;
          }  
      
      }
      img {
        position: relative;
        transition: all .5s;
        -webkit-transition: all .5s;
        -moz-transition: all .5s;
        -o-transition: all .5s;
        -ms-transition: all .5s;
        width: 100%;
        height: 100%;
        background: #ccc;
      }
    }
  }
}
</style>